<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><a class="page" id="piv"></a>Copyright © 2018 by University of Massachusetts Press</p>
<p class="crt">All rights reserved</p>
<p class="crt">Printed in the United States of America</p>
<p class="cipf">ISBN 978-1-61376-575-3</p>
<p class="crtf">Cover design by Kristina Kachele Design, llc</p>
<p class="crt">Cover art: Lovesiyu, <i>Peony</i> © 123RF.com</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">A catalog record for this book is available from the Library of Congress.</p>
<p class="cipf">British Library Cataloguing-in-Publication Data</p>
<p class="cip">A catalog record for this book is available from the British Library.</p>
<p class="crtf">Reference material in “The Birthday Girls” from <i>Bodhisattva of Compassion</i> by John Blofeld. Courtesy of Shambhala Publications.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-HUANG-0006.vue?69be97cf